'use client'

import { type ReactNode } from 'react'

/**
 * Default Session Provider for Better Auth
 * 
 * Better Auth doesn't require a SessionProvider wrapper.
 * The useSession hook works directly without a provider.
 * This component is kept for backwards compatibility but just returns children.
 */
export function DefaultSessionProvider({ children }: { children: ReactNode }) {
  return <>{children}</>
}

